import React from "react";
import { Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { BsArrowRight } from "react-icons/bs";
import styles from "./ServiceCard.module.css";

const ServiceCard = ({ title, desc, link, img }) => {
  return (
    <>
      <Col md={4} className="py-3 ">
        <div className={styles.wrapper}>
          <img src={img} alt={title} className="w-100" />
          <span className={`d-block ${styles.title}`}>{title}</span>
          <span className={`d-block ${styles.desc}`}>{desc}</span>
          <div className="text-end pe-4 d-flex align-items-end justify-content-end">
            <Link to={link} className={styles.icon}>
              <BsArrowRight />
            </Link>
          </div>
        </div>
      </Col>
    </>
  );
};

export default ServiceCard;
